import API_CALL from 'services/API';
const path = 'airtree-project';

const ServiceAirTree = {
  listProjects: async ({
    pagination = true,
    paginationParams = {},
    expand = '',
    search = null,
  }) => {
    let params = {
      pagination,
      ...paginationParams,
      expand,
      ...search,
    };
    return API_CALL({
      url: path,
      params: params,
    }).then((result) => {
      let data = [];
      if (result.pagination) {
        data = result.data;
      } else {
        data = result;
      }
      return {
        data,
        pagination: result.pagination || {},
      };
    });
  },

  get: async ({
    id,
    expand = '',
  }: {
    id?: number;
    expand?: string;
  }) => {
    return API_CALL({ url: path + '/' + id, params: { id, expand } }).then(
      (res) => res
    );
  },

  getRangeSimulationDate: async () => {
    return API_CALL({ url: path + '/get-simulation-date-range' }).then(
      (res) => res
    );
  },

  create: async (data) => {
    return API_CALL({
      method: 'POST',
      url: path,
      data: data,
    });
  },

  delete: async (id: string | number) => {
    return API_CALL({ method: 'DELETE', url: path + '/' + id });
  },

  update: async ({ id, data }: { id: string | number; data: any }) => {
    return API_CALL({ method: 'PUT', url: path + '/' + id, data: data });
  },

  startSimulation: async (idProject) => {
    return API_CALL({
      method: 'GET',
      url: path + '/start-simulation/' + idProject,
    });
  },

  treeTypes: async () => {
    return API_CALL({
      method: 'GET',
      url: path + '/tree-types',
    });
  },

  getTreeType: async (id) => {
    return API_CALL({
      method: 'GET',
      url: path + '/tree-types/' + id,
    });
  },

  clone: async (id) => {
    return API_CALL({
      method: 'POST',
      url: `${path}/clone/${id}`
    });
  },

};
export default ServiceAirTree;
